/**
 * Age Verification Popup
 * Shows popup on first visit and saves verification to localStorage
 * Takes precedence over language popup
 */
(function() {
  'use strict';

  const STORAGE_KEY = 'phi--age-verified';
  const popup = document.getElementById('phi--age-verification-popup');
  
  if (!popup) {
    return;
  }

  const overlay = popup.querySelector('.phi--age-verification-popup__overlay');
  const enterButton = popup.querySelector('[data-action="enter"]');
  const leaveButton = popup.querySelector('[data-action="leave"]');

  // Check if user has already verified their age
  function hasAgeVerified() {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }

  // Save age verification to localStorage
  function saveAgeVerification() {
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  // Show the popup
  function showPopup() {
    if (popup.hasAttribute('hidden')) {
      popup.removeAttribute('hidden');
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }
  }

  // Hide the popup
  function hidePopup() {
    if (!popup.hasAttribute('hidden')) {
      popup.setAttribute('hidden', '');
      // Restore body scroll
      document.body.style.overflow = '';
    }
  }

  // Handle age verification - user is over 21
  function handleEnter() {
    saveAgeVerification();
    hidePopup();
    // Trigger language popup if needed (after age verification)
    triggerLanguagePopup();
  }

  /// Handle age verification - user is under 21
function handleLeave() {
  // Try closing the current tab
  window.open('', '_self'); // Helps in some browsers to allow closing
  window.close();

  // Fallback: if the browser blocks closing, redirect instead
  setTimeout(() => {
    window.location.href = "about:blank";
  }, 200);
}

  // Trigger language popup after age verification
  function triggerLanguagePopup() {
    // Small delay to ensure age popup is fully hidden
    setTimeout(function() {
      const languagePopup = document.getElementById('phi--language-popup');
      if (languagePopup && !localStorage.getItem('phi--language-selected')) {
        languagePopup.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    }, 300);
  }

  // Enter button click handler
  if (enterButton) {
    enterButton.addEventListener('click', function() {
      handleEnter();
    });
  }

  // Leave button click handler
  if (leaveButton) {
    leaveButton.addEventListener('click', function() {
      handleLeave();
    });
  }

  // Overlay click handler - prevent closing on overlay click for age verification
  // Age verification is mandatory
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      // Prevent closing on overlay click - user must make a choice
      e.stopPropagation();
    });
  }

  // Show popup on page load if age hasn't been verified
  if (!hasAgeVerified()) {
    // Small delay to ensure page is fully loaded
    setTimeout(function() {
      showPopup();
    }, 500);
  }
})();


